import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fc77ab3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ChatMessage__container" }
const _hoisted_2 = { class: "container__message" }
const _hoisted_3 = { class: "container__additional" }
const _hoisted_4 = { class: "additional__author" }
const _hoisted_5 = { class: "additional__time" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_message_file = _resolveComponent("message-file")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ChatMessage", { 'ChatMessage--manager': _ctx.isManager }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (Boolean(_ctx.messageFile))
          ? (_openBlock(), _createBlock(_component_message_file, {
              key: 0,
              file: _ctx.messageFile
            }, null, 8, ["file"]))
          : _createCommentVNode("", true),
        (_ctx.messageText)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass({ 'mt-2': Boolean(_ctx.messageFile) })
            }, _toDisplayString(_ctx.messageText), 3))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.isManager)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode("Вы")
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_ctx.messageAuthor), 1)
              ], 64))
        ]),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.formatTimestampToTime(_ctx.message)), 1)
      ])
    ])
  ], 2))
}